import { inject as service } from '@ember/service';
import Route from 'mewe/routes/route';
import { Theme } from 'mewe/constants';

export default Route.extend({
  theme: Theme.PAGE,

  routing: service('-routing'),

  model() {
    return {
      page: this.modelFor('app.publicid').page,
    };
  },

  redirect: function (model, transition) {
    this._super();
    if (transition.targetName === 'app.publicid.settings.users.index') {
      this.routing.transitionTo('app.publicid.settings.users.followers', []);
    }
  },
});
